<template>
  <div id="validateEmail">
    <Background-Image url="surf-sun.jpg" lowResUrl="surf-sun-lowres.jpg" color="#0288D1"></Background-Image>
    <Navigation></Navigation>
    <div id="ValidationSuccessful" class="container-fluid">
      <div class="row p-t-5">
        <div class="offset-md-3 col-md-6">

          <!--Panel if confirmed-->
          <div class="m-t-6 card text-xs-center" v-if="confirmed">
            <div class="card-header success-color-dark white-text">
              {{t('Registration')}}
            </div>
            <div class="card-block">
              <h4 class="card-title">{{t('Email has been confirmed')}}</h4>
              <p class="card-text">{{t('Your account is now active')}}</p>
              <a class="btn btn-success btn-lg" id="registrationSuccessClose" v-on:click="redirectToLogin">Login</a>
            </div>
            <!--div class="card-footer text-muted default-color-dark white-text">
              <p>2 days ago</p>
              </div-->
        </div>
        <!--/.Panel-->

        <!--Panel if not confirmed-->
        <div class="m-t-6 card text-xs-center" v-if="confirmed === false">
          <div class="card-header default-color-dark white-text">
            Account Registration
          </div>
          <div class="card-block">
            <h4 class="card-title">There was an error confirming your email</h4>
            <p class="card-text">If you need assistance please contact us<br/>at info@booknatura.com</p>
            <a class="btn btn-default btn-lg" id="registrationSuccessClose" v-on:click="redirectHome">Home</a>
          </div>
          <!--div class="card-footer text-muted default-color-dark white-text">
            <p>2 days ago</p>
            </div-->
      </div>
      <!--/.Panel-->

      <!--Panel Loading-->
      <div class="m-t-6 card text-xs-center" v-if="loading">
        <div class="card-header default-color-dark white-text">
          Account Registration
        </div>
        <div class="card-block">
          <h4 class="card-title"><i class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i></h4>
          <p class="card-text">Validating your account...</p>
          <button type="button" class="btn btn-default" disabled id="registrationSuccessClose">Login</button>
        </div>
        <!--div class="card-footer text-muted default-color-dark white-text">
          <p>2 days ago</p>
          </div-->
    </div>
    <!--/.Panel-->
  </div>
  </div>
  </div>
  </div>
</template>

<script>
  import request from '../../request';
  import Navigation from '../Navigation/Navigation';
  import BackgroundImage from '../BackgroundImage';

  export default {
    name: 'ValidateEmail',
    components: {
      'Background-Image': BackgroundImage,
      Navigation,
    },
    data() {
      return {
        loading: true,
        confirmed: undefined,
        username: '',
        confirmation_string: '',

      };
    },
    methods: {
      redirectToLogin() {
        this.$router.push(`/${this.$store.state.language}/login`);
      },
      redirectHome() {
        this.$router.push(`/${this.$store.state.language}`);
      },
    },
    mounted() {
      if (typeof this.$route.query.username !== 'undefined') {
        this.username = this.$route.query.username;
      }
      if (typeof this.$route.query.confirmation !== 'undefined') {
        this.confirmation_string = this.$route.query.confirmation;
      }
      request.make({
        type: 'POST',
        url: `${process.env.API_URL}auth/validate`,
        data: {
          username: this.username,
          confirmation_string: this.confirmation_string,
        },
      }, (err, res) => {
        this.loading = false;
        if (res.status === 204) {
          this.confirmed = true;
        } else {
          this.confirmed = false;
        }
      });
    },
  };
</script>


<style type="scss" scoped>
#validateEmail {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// ValidateEmail.vue?18fa9472